import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { WhatYouGet } from '../components/sales/WhatYouGet';
import { ForWhoSection } from '../components/sales/ForWhoSection';
import { HowItWorks } from '../components/sales/HowItWorks';
import { FAQSection } from '../components/sales/FAQSection';
import { OfferSection } from '../components/sales/OfferSection';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full font-body bg-cream selection:bg-gold/30 selection:text-navy" data-id="element-172">
      <HeroSection data-id="element-173" />
      <ProblemSection data-id="element-174" />
      <MechanismSection data-id="element-175" />
      <WhatYouGet data-id="element-176" />
      <ForWhoSection data-id="element-177" />
      <HowItWorks data-id="element-178" />
      <FAQSection data-id="element-179" />
      <OfferSection data-id="element-180" />
      <Footer data-id="element-181" />
    </main>;
}